<template>
  <v-form ref="form" @submit.prevent="onCreateExport">
    <v-card tile>
      <v-card-title class="grey lighten-2">Fordonsrapport</v-card-title>

      <v-card-text class="mt-2">
        <v-row>
          <v-col cols="12">
            <ReportDateTime date-header="Datum" v-model="timestamp" />
          </v-col>
        </v-row>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer />
        <v-btn rounded @click="onClose" :disabled="loading">Avbryt</v-btn>
        <v-btn rounded type="submit" color="primary" :loading="loading"
          >Hämta</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-form>
</template>

<script>
import gql from 'graphql-tag'
import { format, addDays } from 'date-fns'
import ReportDateTime from './ReportDateTime'
import { generateAndDownloadVehicleReport } from './exportGenerator'

export default {
  name: 'vehicle-report',

  components: {
    ReportDateTime
  },

  data() {
    return {
      loading: false,
      timestamp: format(addDays(new Date(), -1), 'yyyy-MM-dd HH:mm')
    }
  },

  methods: {
    async onCreateExport() {
      this.loading = true
      const fileName = `Fordonsrapport ${this.timestamp}`

      const date = new Date(this.timestamp)
      const ts = (format(date, 'yyyy-MM-dd HH:mm:00.000') + 'Z').replace(
        ' ',
        'T'
      )

      const resp = await this.$apollo.query({
        query: gql`
          query vehicleReport($filter: VehicleReportInput!) {
            vehicleReport(filter: $filter)
          }
        `,
        variables: {
          filter: {
            timestamp: ts
          }
        }
      })

      await generateAndDownloadVehicleReport(fileName, resp.data.vehicleReport)
      this.loading = false
      this.onClose()
    },
    onClose() {
      this.$emit('close')
    }
  }
}
</script>
